import { render, staticRenderFns } from "./AioHeaderCategory.vue?vue&type=template&id=27be9711&"
import script from "./AioHeaderCategory.vue?vue&type=script&lang=js&"
export * from "./AioHeaderCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports